import React, { useState, useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import apiCall from "../../common/config/apiCall";
import apiKey from "../../common/config/apiKey";
import ConfirmWithSummary from "./SuccessBookingSummary/SuccessBookingSummary";
import { PremiumLoader } from "../../common/Components/Loader";
import { inComingIncompleteBooking } from "../../common/config/socket";
const BookingConfirm = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [params] = useSearchParams();
  const multi_mode_reference_no = params.get("bookingReference");
  const reference_no = params.get("reference_no");
  const transaction_id = params.get("transactionID");
  const payment_intent = params.get("payment_intent");
  const paymentMethod = params.get("paymentMethod");
  const email_payment = params.get("email_payment");
  const sku = params.get("sku");
  const api_tag = params.get("api_tag");
  const [booking, setBooking] = useState({});
  const [state, setState] = useState("");

  useEffect(() => {
    (async () => {
      setState("loading");
      if (multi_mode_reference_no) {
        const responseBooking = await apiCall(
          "post",
          "/payments/update",
          {
            key: apiKey,
            multi_mode_reference_no,
            reference_no: reference_no?.split(","),
            transaction_id,
            payment_intent,
            payment_type: paymentMethod ? paymentMethod : "stripe",
            api_tag,
            email_payment,
            sku,
          },
          {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          pathname
        );
        console.log(responseBooking, 'responseBooking payment update');
        if (responseBooking?.success) {
          setState("success");
          setBooking(responseBooking);
          inComingIncompleteBooking({
            data: {
              reference_no: Array.isArray(reference_no)
                ? reference_no[0]
                : reference_no,
              db_source: "apd",
            },
            token: apiKey,
          });
        }
      }
    })();
  }, [multi_mode_reference_no]);

  return (
    <div>
      {booking?.data?.length > 0 ? (
        <ConfirmWithSummary bookingDetails={booking?.data} />
      ) : (
        <PremiumLoader
          isLoading={state === "loading"}
          text="Confirming Your Booking"
          subText="Please wait while we process your booking confirmation"
          showProgress={true}
          duration={4000}
          size={70}
          color="#3b82f6"
          spinnerType="ring"
          backgroundColor="bg-black/95"
          textColor="text-white"
          progressColor="from-blue-500 to-green-600"
          showDots={true}
          pulseBackground={true}
        />
      )}
    </div>
  );
};

export default BookingConfirm;
